export const roleValidationService = {
  // Validar nombre de rol
  validateRoleName: (name: string): { isValid: boolean; message?: string } => {
    if (!name || !name.trim()) {
      return { isValid: false, message: 'El nombre del rol es requerido' };
    }
    
    if (name.trim().length < 2) {
      return { isValid: false, message: 'El nombre del rol debe tener al menos 2 caracteres' };
    }
    
    if (name.trim().length > 50) {
      return { isValid: false, message: 'El nombre del rol no puede exceder 50 caracteres' };
    }
    
    return { isValid: true };
  },

  // Validar descripción de rol
  validateRoleDescription: (description: string): { isValid: boolean; message?: string } => {
    if (description && description.length > 200) {
      return { isValid: false, message: 'La descripción no puede exceder 200 caracteres' };
    }
    
    return { isValid: true };
  },

  // Validar si se puede eliminar un rol
  canDeleteRole: (roleName: string): { canDelete: boolean; message?: string } => {
    if (roleName.toLowerCase() === 'admin') {
      return { canDelete: false, message: 'No se puede eliminar el rol de administrador' };
    }
    
    return { canDelete: true };
  }
};
